// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum YearQuarter {
  Q1 = "Q1",
  Q2 = "Q2",
  Q3 = "Q3",
  Q4 = "Q4",
}
export default YearQuarter;
